<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Loader from "../components/loader";
import api from "@/axios";
import DropZone from "@/components/widgets/dropZone.vue";
import moment from "moment";
import Swal from 'sweetalert2';
import { ref } from "vue";
import useVuelidate from "@vuelidate/core";

import { GridComponent, ColumnsDirective, ColumnDirective } from "@syncfusion/ej2-vue-grids";
import { Page, Sort, Filter, Selection } from "@syncfusion/ej2-grids";
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  page: {
    title: "Fretes",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    DropZone,
    Layout,
    PageHeader,
    Loader,
    'ejs-grid': GridComponent,
    'e-columns': ColumnsDirective,
    'e-column': ColumnDirective
  },
  provide: {
    grid: [Page, Sort, Filter, Selection]
  },

  setup() {
    let dropzoneFile = ref("");
    const drop = (e) => {
      dropzoneFile.value = e.dataTransfer.files[0]
    };

    return { v$: useVuelidate(), dropzoneFile, drop };
  },

  data() {
    return {
      submitted: false,

      updating: true,
      numeroNf: '',
      userLogged: {},
      clickBusca:'AB',
      listaNotas:[],

      showModalAnexo: false,
      submittedAnexo: false,
      descranexo: '',
      loadingFiles: false,


      modalEditarStatus: false,
      showModaleditarPed: false,
      selectedItem: null,

      idData: 0,
      ocorrencia: {
        status: '',
        descricao: '',
        dtocorrencia: null,
        dtprevisao: null
      },

      showModalPeriodo: false,
      dtFimFormated: null,
      dtIniFormated: null,
      dtIniFiltro: null,
      dtIniFiltroFormated: null,
      dtFimFiltroFormated: null,
      dtFimFiltro: null,
      submittedPeriodo: null,
      reloadTime: 0,

      exibEmit: true,
      exibDest: false,
      exibAmbos: false,

      title: "Data",
      items: [
        {
          text: "Dashboards",
          href: "/",
        },
        {
          text: "Controle de Entregas",
          active: true,
        },
      ],

      pageSettings: {
        pageSize: 30,
        pageSizes: [30, 50, 100],
        showSettings: true
      },
      filterSettings: {
        type: 'Excel'
      },
      tamanhoTela: 0,
      activeStep: 1,
    };
  },

  created() {
    this.dtIniFiltro = moment().subtract(30,'days').startOf('day').format('YYYY-MM-DD 00:00:00');
    this.dtFimFiltro = moment().endOf('day').format('YYYY-MM-DD 23:59:59');
  },

  mounted() {
    console.log('mounted_dashFrete')
    this.tamanhoTela = window.innerWidth

    this.atualizaDataList();

  },

  methods: {
    goToStep(step){
      console.log('goToStep', step)
      this.activeStep = step;
    },

    confirmarPeriodo(){
      console.log('confirmarPeriodo')

      localStorage.setItem('filtros', JSON.stringify({
        'movdi': moment(this.dtIniFiltro).format('YYYY-MM-DD'),
        'movdf': moment(this.dtFimFiltro).format('YYYY-MM-DD'),
      }))

      this.showModalPeriodo = false
      this.atualizaDataList()
    },

    confirmarEdicao(){
      console.log('confirmarEdicao')
      this.submitted = true

      const { tipo, status, descricao, dtocorrencia } = this.ocorrencia;

      if (tipo && status && descricao && dtocorrencia) {
        api.post(`${getBaseUrl()}api/editstatus`, {
        idData: this.idData,
        ocorrenciaData: this.ocorrencia
      }).then((res) => {

        this.showModaleditarPed = false

        console.log(res)
      //Verificando retorno
      if(res.data.success === true){
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: res.data.mensagem,
          showConfirmButton: false,
          timer: 2000
        }).then(() => {
          this.modalEditarStatus = false
          this.numeroNf = null
          this.atualizaDataList()
        })
      }
      else{
        Swal.fire({
          position: "top-end",
          icon: "error",
          title: res.data.mensagem,
          showConfirmButton: false,
          timer: 2000
        }).then(() => {
          this.modalEditarStatus = false
          this.numeroNf = null
          this.atualizaDataList()
        })
      }
    })
    } else {
        Swal.fire({
        icon: 'warning',
        title: 'Preencha todos os campos obrigatórios!',
        showConfirmButton: false,
        timer: 2000
        });
        }
      },
    onRowSelected(args) {
      this.editarPed(args.data);
    },

    getStatusText(status) {
      const statusMap = {
        'EL': 'Elaborada',
        'NEM': 'Não Emitida',
        'OS': 'OS Criada',
        'CF': 'Confirmada',
        'CCT': 'CT-e Criado',
        'TRA': 'Em Trânsito',
        'SE': 'Saída Expedição',
        'CTE': 'CT-e Emitido',
        'ENP': 'Entrega Normal',
        'ECR': 'Entrega c/ Restrição',
        'EAT': 'Entrega Atrasada',
        'CA': 'Cancelada',
        'EAP': 'Entrega Antecipada'
      };
      return statusMap[status] || status;
    },

    getStatusBadgeClass(status) {
      const finalizados = ['ENP', 'ECR', 'EAT', 'CA', 'EAP'];
      return finalizados.includes(status) ? 'bg-success' : 'bg-warning text-dark';
    },   

    buscaNf() {
      if(this.numeroNf) {
        this.clickBusca = 'busca'
      }
      this.atualizaDataList()
    },

    emAberto() {
      this.clickBusca = 'AB'
      this.activeStep = 2
      this.atualizaDataList()
    },

    nfFinalizada() {
      this.clickBusca = 'FN'
      this.activeStep = 2
      this.atualizaDataList()
    },

    atualizaDataList(){
      console.log("atualizaDataList");
      this.updating = true

      const filtros = JSON.parse(localStorage.getItem("filtros"))

      if (!filtros) {
        console.log('cookie dataMov não existe, criando')
        let perIniPadrao = moment(new Date())
        .add(-15, 'days')
        .format('YYYY-MM-DD')
        let perFimPadrao = moment(new Date())
        .format('YYYY-MM-DD')
        this.dtIniFiltro = perIniPadrao
        this.dtFimFiltro = perFimPadrao
        localStorage.setItem('filtros', JSON.stringify({
          'movdi': perIniPadrao,
          'movdf': perFimPadrao,
        }))
      } else {
        this.dtIniFiltro = filtros['movdi']
        this.dtFimFiltro = filtros['movdf']
      }

      if (!this.dtIniFiltro && !this.dtFimFiltro){
        console.log('sem filtro')
        let perIniPadrao = moment(new Date())
        .add(-15, 'days')
        .format('YYYY-MM-DD')
        let perFimPadrao = moment(new Date())
        .format('YYYY-MM-DD')
        this.dtIniFiltro = perIniPadrao
        this.dtFimFiltro = perFimPadrao
      }

      const numeroNf = this.numeroNf
      const di = this.dtIniFiltro
      const df = this.dtFimFiltro
      const clickBusca = this.clickBusca
      const paramsReq = {
        'numeroNf': numeroNf,
        'di': di,
        'df': df,
        'clickBusca': clickBusca
      }

      try{
        api.get(`${getBaseUrl()}api/controlentrega`, {
          params: paramsReq
        }).then((res) => {
          console.log("response");
          console.log(res.data);

          if (res.data[0] === 'erro') {

            Swal.fire({
              text: res.data[1],
              icon: "warning",
              position: "top-end",
              showConfirmButton: false,
              timer: 1500
            })


          } else {
            this.trataRetorno(res);
            // this.modalEditarStatus = false
          }
          this.updating = false
        });
      }catch(error){
        console.log('Erro método atualizaDataList: '+ error);
      }
    },

    trataRetorno(res) {
      console.log('trataRetorno');

      if(res.status === 204){
        Swal.fire({
          position: "top-end",
          icon: "error",
          title: "Não há nenhum registro conforme parametro enviado!",
          showConfirmButton: false,
          timer: 5000
        });

      }else{
        if (typeof res.data.dtIniFiltro === 'string' && typeof res.data.dtFimFiltro === 'string') {
          this.dtIniFormated = res.data.dtIniFiltro.split('-');
          this.dtIniFormated = `${this.dtIniFormated[2].substr(0, 2)}/${this.dtIniFormated[1]}/${this.dtIniFormated[0]}`;

          this.dtFimFormated = res.data.dtFimFiltro.split('-');
          this.dtFimFormated = `${this.dtFimFormated[2].substr(0, 2)}/${this.dtFimFormated[1]}/${this.dtFimFormated[0]}`;

          this.title = `Fretes: ${this.dtIniFormated} - ${this.dtFimFormated}`;

          this.listaNotas = res.data.movWmsRomaneio;

          this.sttAB = res.data.sttAB;
          this.countAB = res.data.sttAB;

          this.sttFN = res.data.sttFN;
          this.countFN = res.data.sttFN;

          console.log('movWmsRomaneio :::');
          console.log(this.listaNotas);

          console.log('countAB :::');
          console.log(this.countAB);
          console.log('countFN :::');
          console.log(this.countFN);

          this.sttBusca = res.data.sttBusca;
          this.clickBusca = this.sttBusca;
          console.log('this.clickBusca >>>>');
          console.log(this.clickBusca);
        }
      }
    },

    novoAnexo(){
      console.log('novoAnexo')
      this.descranexo = ''
      this.submittedAnexo = false
      this.showModalAnexo = true
      // this.activeTab = 2
    },

    confAnexo(){
      console.log('confAnexo')
      this.submittedAnexo = true
      if (this.descranexo !== '' && this.dropzoneFile.name){
        this.showModalAnexo = false
        this.loadingFiles = true

        let arquivo = document.querySelector(".dropzoneFile").files[0]
        console.log(arquivo)
        let formData = new FormData()
        formData.append("iddata", this.idData)
        formData.append("descranexo", this.descranexo)
        formData.append("filename", arquivo.name)
        formData.append("file", arquivo)

        api.post(`${getBaseUrl()}api/movfileanexonew`,formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(JSON.stringify(res.data))

          this.mediasData = res.data[0]
          this.loadingFiles = false

          // this.showModaleditarPed = false

          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })
        }).catch((err) => {

          console.log('erro axios')
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof  erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros

          Swal.fire({
            position: "center",
            icon: "error",
            title: "Upload de comprovante falhou!",
            text: "Talvez o arquivo seja muito grande!",
            showConfirmButton: false,
            timer: 2500
          })

          this.loadingFiles = false
        })
      }
    },

    selectedFile(){
      console.log('selectedFile')
      this.dropzoneFile = document.querySelector(".dropzoneFile").files[0]
      console.log('selectedFile')

    },

    editarPed(item) {
      this.selectedItem = item;
      this.showModaleditarPed = true;
      this.ocorrencia = {
        dtprevisao: item.dtpreventr ? moment(item.dtpreventr).format('YYYY-MM-DD') : null
      }
      this.submitted = false


      this.idData = this.selectedItem.id;

        },

    retornaMenu(){
      console.log('retornaMenu')
      this.$router.replace('/')
    },

        atualizaStatus(){
      console.log('0000_atualizaStatus_0000')

      api.post(`${getBaseUrl()}api/editstatus`, {
        idData: this.idData,
        ocorrenciaData: this.ocorrencia
      }).then((res) => {
        console.log(res)
        //Verificando retorno
        if(res.data.success === true){
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: res.data.mensagem,
            showConfirmButton: false,
            timer: 2000
          }).then(() => {
            this.modalEditarStatus = false
            this.atualizaDataList()
          })
        }else{
          Swal.fire({
            position: "top-end",
            icon: "error",
            title: res.data.mensagem,
            showConfirmButton: false,
            timer: 2000
          }).then(() => {
            this.modalEditarStatus = false
            this.atualizaDataList()
          })
        }
      })
    },

    handleScroll() {
      if (this.$refs.current.$el) {
        setTimeout(() => {
          this.$refs.current.SimpleBar.value.getScrollElement().scrollTop =
              this.$refs.current.SimpleBar.value.getScrollElement().scrollHeight + 1500;
        }, 500);
      }
    },

    formatDecimal(value) {
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return 0.00;
    },

    formatInteger(value) {
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 0});
      }
      return 0.00;
    },

    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },
    
  },
};
</script>


<template>
  <div v-if="tamanhoTela > 500">
    <Layout>
      <PageHeader :title="title" :items="items" @click="showModalPeriodo=true" />

      <div v-if="(dtIniFiltro == 0 || dtIniFiltro == null) && !updating" class="alert alert-danger" role="alert">
        Não existe informações para o período informado
      </div>

      <Loader class="mt-4" v-if="updating" style="min-height: 150px;">
      </Loader>

      <div class="row" v-if="!updating">
        <b-container>
          <b-row>
            <div class="card bg-soft bg-primary">
              <div class="d-flex justify-content-around">
                <div class="text-primary p-3">
                  <h5 class="text-primary font-size-18">Controle de Entregas</h5>
                  <p>Bem vindo!</p>
                </div>
                <div style="max-width: 220px">
                  <img
                      src="@/assets/images/transporte.png"
                      alt
                      class="img-fluid"
                      />
                </div>
              </div>
            </div>
          </b-row>

          <b-row>
            <div class="card">
              <div class="card-body">
                <div class="d-flex flex-wrap justify-content-around mt-4">
                  <div class="d-flex align-items-center mb-3">
                    <div class="avatar-xs me-3">
                      <span
                          class="
                          avatar-title
                          rounded-circle
                          bg-soft bg-primary
                          text-primary
                          font-size-18">
                        <i class="bx bx-archive-in"></i>
                      </span>
                    </div>
                    <h5 class="font-size-14 mb-0">Entregas <br>Em Aberto</h5>
                    <button type="button" @click="emAberto" class="btn btn-warning font-size-22"
                            style="margin-top: -5px; margin-bottom: -7px; margin-left: 85px; min-width: 120px; padding: 0px"
                            > {{ this.countAB }} </button>
                  </div>

                  <div class="d-flex align-items-center mb-3">
                    <div class="avatar-xs me-3">
                      <span
                          class="
                          avatar-title
                          rounded-circle
                          bg-soft bg-primary
                          text-primary
                          font-size-18">
                        <i class="bx bx-archive-in"></i>
                      </span>
                    </div>
                    <h5 class="font-size-14 mb-0">Entregas <br> Finalizadas</h5>
                    <button type="button" @click="nfFinalizada" class="btn btn-success font-size-22"
                            style="margin-top: -5px; margin-bottom: -7px; margin-left: 80px; min-width: 120px; padding: 0px"
                            >{{ this.countFN }}</button>
                  </div>
                </div>
              </div>
            </div>
          </b-row>

          <b-row>
            <div class="card">
              <div class="card-body">
                <div class="text-center mb-3">
                  <h5 class="font-size-16 mb-0">Pesquisar NF</h5>
                </div>
                <div class ="d-flex justify-content-center">
                  <div class="col-6 text-muted mt-4">
                    <input
                        v-model="numeroNf"
                        id="nroori"
                        type="text"
                        style="font-size: 12px;"
                        v-on:keyup.enter="buscaNf"
                        class="form-control"
                        placeholder="Número NF"
                        :disabled="false"/>
                  </div>
                  <div>
                    <button type="button" @click="buscaNf" class="btn btn-info font-size-18 mt-4"
                      style="margin-left:43px; min-width: 120px; padding: 3px">
                      Buscar
                    </button>
                  </div>
                </div>

                <!-- Syncfusion Grid Component -->
                <div class="text-center" style="margin-top: 8ch">
                  <div v-if="clickBusca === 'AB'" class="table-responsive mb-0">
                    <div class="text-center mb-3" style="background-color: #efb34b;">
                      <h5 style="color: #fff; padding: 6px"> Entregas em Aberto </h5>
                    </div>
                    <ejs-grid
                            :dataSource="listaNotas"
                            ref="gridAberto"
                            :allowFiltering="true"
                            :allowPaging="true"
                            :filterSettings="filterSettings"
                            :allowSorting="true"
                            :pageSettings="pageSettings"
                            :rowSelected="onRowSelected"
                            height="400"
                            >

                      <e-columns>
                        <e-column field="codigo" headerText="NF" width="120" textAlign="Center" :template="'nfTemplate'">
                        </e-column>

                        <e-column field="nome" headerText="Destinatário" width="300" :template="'destinatarioTemplate'">
                        </e-column>

                        <e-column field="dtemissao" headerText="Data Emissão" width="150" textAlign="Center"
                          :template="'dataTemplate'">
                        </e-column>

                        <e-column field="status" headerText="Status" width="120" textAlign="Center"
                          :template="'statusTemplate'">
                        </e-column>
                      </e-columns>
                      <template v-slot:nfTemplate="{ data }">
                        <a href="javascript: void(0);" @click="editarPed(data)" class="text-body fw-bold">
                          {{ data.codigo }}</a>
                      </template>

                      <template v-slot:destinatarioTemplate="{ data }">
                        <a href="javascript: void(0);" @click="editarPed(data)" class="text-body fw-bold">
                          <span :title="data.nome">{{ data.nome.length > 30 ? data.nome.substr(0, 30) + '...' : data.nome
                            }}</span>
                        </a>
                      </template>

                      <template v-slot:dataTemplate="{ data }">
                        <a href="javascript:void(0);" @click="editarPed(data)" class="text-body fw-bold">
                          {{ formatDateTime(data.dtemissao) }}
                        </a>
                      </template>

                      <template v-slot:statusTemplate="{ data }">
                        <span class="badge bg-warning text-dark">{{ getStatusText(data.status) }}</span>
                      </template>
                    </ejs-grid>
                  </div>

                  <div v-else-if="clickBusca === 'FN'" class="table-responsive mb-0">
                    <div class="text-center mb-3" style="background-color: #34c18e;">
                      <h5 style="color: #fff; padding: 2px"> Entregas Finalizadas </h5>
                    </div>
                    <ejs-grid ref="gridFinalizado" :dataSource="listaNotas" :allowPaging="true" :allowSorting="true"
                      :allowFiltering="true" :pageSettings="pageSettings" :filterSettings="filterSettings"
                      :rowSelected="onRowSelected" height="400">

                      <e-columns>
                        <e-column field="codigo" headerText="NF" width="120" textAlign="Center" :template="'nfTemplate'">
                        </e-column>

                        <e-column field="nome" headerText="Destinatário" width="300" :template="'destinatarioTemplate'">
                        </e-column>

                        <e-column field="dtemissao" headerText="Data Emissão" width="150" textAlign="Center"
                          :template="'dataTemplate'">
                        </e-column>

                        <e-column field="status" headerText="Status" width="120" textAlign="Center"
                          :template="'statusTemplate'">
                        </e-column>
                      </e-columns>
                      <template v-slot:nfTemplate="{ data }">
                        <a href="javascript: void(0);" @click="editarPed(data)" class="text-body fw-bold">
                          {{ data.codigo }}</a>
                      </template>
                      <template v-slot:destinatarioTemplate="{ data }">
                        <a href="javascript: void(0);" @click="editarPed(data)" class="text-body fw-bold">
                          <span :title="data.nome">{{ data.nome.length > 30 ? data.nome.substr(0, 30) + '...' : data.nome
                            }}</span>
                        </a>
                      </template>
                      <template v-slot:dataTemplate="{ data }">
                        <a href="javascript:void(0);" @click="editarPed(data)" class="text-body fw-bold">
                          {{ formatDateTime(data.dtemissao) }}
                        </a>
                      </template>

                      <template v-slot:statusTemplate="{ data }">
                        <span class="badge bg-success">{{ getStatusText(data.status) }}</span>
                      </template>
                    </ejs-grid>
                  </div>

                  <div v-else-if="clickBusca === 'busca'" class="mb-4">
                    <div class="text-center mb-3" style="background-color: #556ee6;">
                      <h5 style="color: #fff; padding: 6px">Resultado da Busca</h5>
                    </div>

                    <ejs-grid ref="gridBusca" :dataSource="listaNotas" :allowPaging="true" :allowSorting="true"
                      :allowFiltering="true" :pageSettings="pageSettings" :filterSettings="filterSettings"
                      :rowSelected="onRowSelected" height="400">

                      <e-columns>
                        <e-column field="codigo" headerText="NF" width="120" textAlign="Center" :template="'nfTemplate'">
                        </e-column>

                        <e-column field="nome" headerText="Destinatário" width="300" :template="'destinatarioTemplate'">
                        </e-column>

                        <e-column field="dtemissao" headerText="Data Emissão" width="150" textAlign="Center"
                          :template="'dataTemplate'">
                        </e-column>

                        <e-column field="status" headerText="Status" width="120" textAlign="Center"
                          :template="'statusTemplate'">
                        </e-column>
                      </e-columns>
                      <template v-slot:nfTemplate="{ data }">
                        <a href="javascript:void(0);" @click="editarPed(data)" class="text-body fw-bold text-info">
                          {{ data.codigo }}
                        </a>
                      </template>

                      <template v-slot:destinatarioTemplate="{ data }">
                        <a href="javascript:void(0);" @click="editarPed(data)" class="text-body fw-bold">
                          <span :title="data.nome">{{ data.nome.length > 30 ? data.nome.substr(0, 30) + '...' : data.nome
                            }}</span>
                        </a>
                      </template>

                      <template v-slot:dataTemplate="{ data }">
                        <a href="javascript:void(0);" @click="editarPed(data)" class="text-body fw-bold">
                          {{ formatDateTime(data.dtemissao) }}
                        </a>
                      </template>

                      <template v-slot:statusTemplate="{ data }">
                        <span class="badge" :class="getStatusBadgeClass(data.status)">{{ getStatusText(data.status)
                          }}</span>
                      </template>
                    </ejs-grid>
                  </div>
                </div>
              </div>
            </div>
          </b-row>
        </b-container>
      </div>

    </Layout>
  </div>

  <div class="col-lg-12 full-height-wrapper" v-if="!updating && tamanhoTela < 500">

    <div v-if="(dtIniFiltro == 0 || dtIniFiltro == null) && !updating" class="alert alert-danger" role="alert">
      Não existe informações para o período informado
    </div>

    <Loader class="mt-4" v-if="updating" style="min-height: 150px;">
    </Loader>

    <div class="card full-height-card">
      <div class="card-body full-height-body">
        <button title="Return" @click="retornaMenu" class="btn col-1 p-1 m-1 border-0 font-size-16"
                style="position: fixed; top: 0px; right: 5px; background-color: white; z-index: 1000;"
        >
          <i class="bx bx-undo"></i>
        </button>



        <form class="needs-validation">
          <div id="step1" v-if="activeStep === 1" class="row">

            <b-container style="margin-top: 26px">
              <b-row>
                <div class="card bg-soft bg-primary">

                  <div class="text-primary p-3">
                    <h5 class="text-primary font-size-18">Controle de Entregas</h5>
                    <p>Bem vindo!</p>
                    <div class="cursor-pointer d-inline-block"
                         @click="showModalPeriodo = true"
                         style="position: relative; z-index: 1000;">
                      <span><strong>Período:</strong></span>
                      <p>{{`${formatDateTime(this.dtIniFiltro)} - ${formatDateTime(this.dtFimFiltro)}`}}</p>
                    </div>
                  </div>

                  <img
                      src="@/assets/images/transporte.png"
                      alt
                      class="img-fluid"
                      style="max-width: 120px; position: fixed; top: 131px; right: 20px; z-index: 1;"
                  />

                </div>
              </b-row>
            </b-container>

            <div class="col-sm-12 mt-2 mb-3">
                <div class="row mb-3">
                  <div class="col-6">
                    <h5 class="font-size-14 mb-0">Entregas <br>Em Aberto</h5>
                  </div>
                  <div class="col-6">
                    <button type="button" @click="emAberto" class="btn btn-warning font-size-22"
                          style="min-width: 120px; padding: 0px"
                    >
                      {{ this.countAB }}
                    </button>
                  </div>
                </div>

                <div class="row mb-3">
                  <div class="col-6">
                    <h5 class="font-size-14 mb-0">Entregas <br> Finalizadas</h5>
                  </div>
                  <div class="col-6">
                    <button type="button" @click="nfFinalizada" class="btn btn-success font-size-22"
                            style="min-width: 120px; padding: 0px"
                    >
                      {{ this.countFN }}
                    </button>
                  </div>
                </div>
            </div>

            <div class="nav-buttons">
              <button type="button" disabled class="btn-nav btn-back">
                Voltar
              </button>
              <button type="button" class="btn-nav btn-next" @click="goToStep(2)">
                Próximo
              </button>
            </div>
          </div>

          <div id="step2" v-if="activeStep === 2" class="row mb-4">

            <div class="col-sm-12 mb-5">

                <div class="row mt-2 mb-3">
                  <div class="col-6">
                    <label for="nroori">Pesquisar NF</label>
                    <input
                        v-model="numeroNf"
                        id="nroori"
                        type="text"
                        style="font-size: 12px;"
                        v-on:keyup.enter="buscaNf"
                        class="form-control"
                        placeholder="Número NF"
                        :disabled="false"/>
                  </div>
                  <div class="col-5 ms-3" style="margin-top: 5px ;">
                    <button type="button" @click="buscaNf" class="btn btn-info font-size-18 mt-4"
                            style="min-width: 100px; padding: 2px">
                      Buscar
                    </button>
                  </div>
                </div>

                  <!-- Syncfusion Grid Component -->
                  <div class="text-center" style="margin-top: 5ch">
                    <div v-if="clickBusca === 'AB'" class="table-responsive mb-0" style="max-height: 267px; overflow-y: auto;">
                      <div class="text-center mb-3" style="background-color: #efb34b;">
                        <h5 style="color: #fff; padding: 6px"> Entregas em Aberto </h5>
                      </div>
                      <ejs-grid
                          :dataSource="listaNotas"
                          ref="gridAberto"
                          :allowFiltering="true"
                          :allowPaging="true"
                          :filterSettings="filterSettings"
                          :allowSorting="true"
                          :pageSettings="pageSettings"
                          :rowSelected="onRowSelected"
                          height="400"
                      >

                        <e-columns>
                          <e-column field="codigo" headerText="NF" width="120" textAlign="Center" :template="'nfTemplate'">
                          </e-column>

                          <e-column field="nome" headerText="Destinatário" width="300" :template="'destinatarioTemplate'">
                          </e-column>

                          <e-column field="dtemissao" headerText="Data Emissão" width="150" textAlign="Center"
                                    :template="'dataTemplate'">
                          </e-column>

                          <e-column field="status" headerText="Status" width="120" textAlign="Center"
                                    :template="'statusTemplate'">
                          </e-column>
                        </e-columns>
                        <template v-slot:nfTemplate="{ data }">
                          <a href="javascript: void(0);" @click="editarPed(data)" class="text-body fw-bold">
                            {{ data.codigo }}</a>
                        </template>

                        <template v-slot:destinatarioTemplate="{ data }">
                          <a href="javascript: void(0);" @click="editarPed(data)" class="text-body fw-bold">
                            <span :title="data.nome">{{ data.nome.length > 30 ? data.nome.substr(0, 30) + '...' : data.nome
                              }}</span>
                          </a>
                        </template>

                        <template v-slot:dataTemplate="{ data }">
                          <a href="javascript:void(0);" @click="editarPed(data)" class="text-body fw-bold">
                            {{ formatDateTime(data.dtemissao) }}
                          </a>
                        </template>

                        <template v-slot:statusTemplate="{ data }">
                          <span class="badge bg-warning text-dark">{{ getStatusText(data.status) }}</span>
                        </template>
                      </ejs-grid>
                    </div>

                    <div v-else-if="clickBusca === 'FN'" class="table-responsive mb-0">
                      <div class="text-center mb-3" style="background-color: #34c18e;">
                        <h5 style="color: #fff; padding: 2px"> Entregas Finalizadas </h5>
                      </div>
                      <ejs-grid ref="gridFinalizado" :dataSource="listaNotas" :allowPaging="true" :allowSorting="true"
                                :allowFiltering="true" :pageSettings="pageSettings" :filterSettings="filterSettings"
                                :rowSelected="onRowSelected" height="400">

                        <e-columns>
                          <e-column field="codigo" headerText="NF" width="120" textAlign="Center" :template="'nfTemplate'">
                          </e-column>

                          <e-column field="nome" headerText="Destinatário" width="300" :template="'destinatarioTemplate'">
                          </e-column>

                          <e-column field="dtemissao" headerText="Data Emissão" width="150" textAlign="Center"
                                    :template="'dataTemplate'">
                          </e-column>

                          <e-column field="status" headerText="Status" width="120" textAlign="Center"
                                    :template="'statusTemplate'">
                          </e-column>
                        </e-columns>
                        <template v-slot:nfTemplate="{ data }">
                          <a href="javascript: void(0);" @click="editarPed(data)" class="text-body fw-bold">
                            {{ data.codigo }}</a>
                        </template>
                        <template v-slot:destinatarioTemplate="{ data }">
                          <a href="javascript: void(0);" @click="editarPed(data)" class="text-body fw-bold">
                            <span :title="data.nome">{{ data.nome.length > 30 ? data.nome.substr(0, 30) + '...' : data.nome
                              }}</span>
                          </a>
                        </template>
                        <template v-slot:dataTemplate="{ data }">
                          <a href="javascript:void(0);" @click="editarPed(data)" class="text-body fw-bold">
                            {{ formatDateTime(data.dtemissao) }}
                          </a>
                        </template>

                        <template v-slot:statusTemplate="{ data }">
                          <span class="badge bg-success">{{ getStatusText(data.status) }}</span>
                        </template>
                      </ejs-grid>
                    </div>

                    <div v-else-if="clickBusca === 'busca'" class="mb-4">
                      <div class="text-center mb-3" style="background-color: #556ee6;">
                        <h5 style="color: #fff; padding: 6px">Resultado da Busca</h5>
                      </div>

                      <ejs-grid ref="gridBusca" :dataSource="listaNotas" :allowPaging="true" :allowSorting="true"
                                :allowFiltering="true" :pageSettings="pageSettings" :filterSettings="filterSettings"
                                :rowSelected="onRowSelected" height="400">

                        <e-columns>
                          <e-column field="codigo" headerText="NF" width="120" textAlign="Center" :template="'nfTemplate'">
                          </e-column>

                          <e-column field="nome" headerText="Destinatário" width="300" :template="'destinatarioTemplate'">
                          </e-column>

                          <e-column field="dtemissao" headerText="Data Emissão" width="150" textAlign="Center"
                                    :template="'dataTemplate'">
                          </e-column>

                          <e-column field="status" headerText="Status" width="120" textAlign="Center"
                                    :template="'statusTemplate'">
                          </e-column>
                        </e-columns>
                        <template v-slot:nfTemplate="{ data }">
                          <a href="javascript:void(0);" @click="editarPed(data)" class="text-body fw-bold text-info">
                            {{ data.codigo }}
                          </a>
                        </template>

                        <template v-slot:destinatarioTemplate="{ data }">
                          <a href="javascript:void(0);" @click="editarPed(data)" class="text-body fw-bold">
                            <span :title="data.nome">{{ data.nome.length > 30 ? data.nome.substr(0, 30) + '...' : data.nome
                              }}</span>
                          </a>
                        </template>

                        <template v-slot:dataTemplate="{ data }">
                          <a href="javascript:void(0);" @click="editarPed(data)" class="text-body fw-bold">
                            {{ formatDateTime(data.dtemissao) }}
                          </a>
                        </template>

                        <template v-slot:statusTemplate="{ data }">
                          <span class="badge" :class="getStatusBadgeClass(data.status)">{{ getStatusText(data.status)
                            }}</span>
                        </template>
                      </ejs-grid>
                    </div>
                  </div>




              <div class="nav-buttons">
                <button type="button" class="btn-nav btn-back" @click="goToStep(1)">
                  Voltar
                </button>
                <button type="button" disabled class="btn-nav btn-next" >
                  Próximo
                </button>
              </div>
            </div>
          </div>
        </form>

      </div>
    </div>
  </div>

  <b-modal title="Período de Exibição" v-model="showModalPeriodo" centered hide-footer>
    <div class="col-md-12">
      <div class="mb-3">
        <label for="tipooperacao">Selecionar Data Inicial e Final</label>

      </div>
    </div>
    <div class="row">

      <div class="col-md-6">
        <div class="mb-3">
          <label for="dtIniFiltro">Data Início</label>
          <input
              id="dtIniFiltro"
              v-model="dtIniFiltro"
              type="date"
              class="form-control"
              placeholder="Data Início"
              :class="{'is-invalid': submittedPeriodo && !dtIniFiltro,}"/>
          <div v-if="submittedPeriodo && !dtIniFiltro"
               class="invalid-feedback">
            <span >Campo data início obrigatório, favor preencher.</span>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="mb-3">
          <label for="dtFimFiltro">Data Final</label>
          <input
              id="dtFimFiltro"
              v-model="dtFimFiltro"
              type="date"
              class="form-control"
              placeholder="Data Final"
              :class="{'is-invalid': submittedPeriodo && !dtFimFiltro,}"/>
          <div v-if="submittedPeriodo && !dtFimFiltro"
               class="invalid-feedback">
            <span >Campo data final obrigatória, favor preencher.</span>
          </div>
        </div>
      </div>
    </div>

    <div class="text-end mt-5">
      <b-button variant="light" @click="showModalPeriodo = false">
        <i class="bx bx-block font-size-16 align-middle me-2"></i>
        Cancelar
      </b-button>
      <b-button type="submit" variant="success" class="ms-1" @click="confirmarPeriodo">
        <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
        Confirmar
      </b-button>
    </div>
  </b-modal>

  <b-modal title="NF Selecionada" v-model="showModaleditarPed" v-if="selectedItem" centered hide-footer>
    <div class="col-md-12">
      <div>
        <div class="d-flex">
          <p><strong>Nro NF:</strong> {{ selectedItem.codigo }}</p>
          <p style="margin-left: 7ch"><strong>Data de Emissão:</strong> {{ formatDateTime(selectedItem.dtemissao) }}</p>
        </div>
        <div>
          <p><strong>Nome:</strong> {{ selectedItem.nome }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="mb-3">
          <label for="ocorrencia.tipo">Tipo da ocorrência</label>
          <select
              id="ocorrencia.tipo"
              v-model="ocorrencia.tipo"
              class="form-control"
              :class="{'is-invalid': submitted && !ocorrencia.tipo}">
            <option value="informativo">Informativo</option>
            <option value="entrega">Entrega</option>
            <option value="ocorrencia">Ocorrência</option>
          </select>
          <div v-if="submitted && !ocorrencia.tipo" class="invalid-feedback">
            <span>Campo tipo obrigatório, favor preencher.</span>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="mb-3">
          <label for="ocorrencia.status">Status</label>
          <select
              id="ocorrencia.status"
              v-model="ocorrencia.status"
              class="form-control"
              :class="{'is-invalid': submitted && !ocorrencia.status}">
            <option value="nfeEmit">NF-e emitida</option>
            <option value="nfeCanc">NF-e cancelada</option>
            <option value="cteEmit">CT-e emitido</option>
            <option value="cteCanc">CT-e cancelado</option>
            <option value="transf">Em trânsito</option>
            <option value="entregue">Entregue</option>
            <option value="ocorrencia">Entregue com ocorrência</option>
            <option value="insentrega">Insucesso de entrega</option>
          </select>
          <div v-if="submitted && !ocorrencia.status" class="invalid-feedback">
            <span>Campo status obrigatório, favor preencher.</span>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="mb-3">
          <label
              class="mb-1 mt-3 fw-medium"
              for="ocorrencia.descricao">Descrição</label>
          <textarea
              id="ocorrencia.descricao"
              v-model="ocorrencia.descricao"
              class="form-control"
              :maxlength="225"
              rows="3"
              placeholder="Limite de 255 caracteres."
              :class="{'is-invalid': submitted && !ocorrencia.descricao}">
          </textarea>
          <div class="text-center">
            <p v-if="ocorrencia.descricao"
               class="badge position-absolute"
               :class="{ 'bg-success': ocorrencia.descricao.length !== 225, 'bg-danger': ocorrencia.descricao.length === 225 }">
              {{ ocorrencia.descricao.length }} / 225
            </p>
          </div>
          <div v-if="submitted && !ocorrencia.descricao" class="invalid-feedback">
            <span>Campo descrição obrigatório, favor preencher.</span>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="mb-3">
          <label for="ocorrencia.dtocorrencia">
            Data Ocorrência
          </label>
          <b-form-input
              id="ocorrencia.dtocorrencia"
              v-model="ocorrencia.dtocorrencia"
              type="date"
              :class="{'is-invalid': submitted && !ocorrencia.dtocorrencia}">
          </b-form-input>
        </div>
        <div v-if="submitted && !ocorrencia.dtocorrencia" class="invalid-feedback">
          <span>Campo data de ocorrencia obrigatório, favor preencher.</span>
        </div>
      </div>

      <div class="col-md-6">
        <div class="mb-3">
          <label for="ocorrencia.dtprevisao">
            Previsão de entrega
          </label>
          <b-form-input
              id="ocorrencia.dtprevisao"
              v-if="selectedItem.flagslaentrega"
              v-model="ocorrencia.dtprevisao"
              type="date"
              disabled>
          </b-form-input>
          <b-form-input
              id="ocorrencia.dtprevisao"
              v-else
              v-model="ocorrencia.dtprevisao"
              type="date">
          </b-form-input>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="text-end mt-5">
        <b-button variant="outline-info" @click="novoAnexo">
          <i class="bx bx-upload font-size-16 align-middle me-2"></i>
          Anexar Comprovante
        </b-button>

        <b-button type="submit" variant="success" class="ms-1" @click="confirmarEdicao">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </div>
  </b-modal>

  <b-modal title="Criar Novo Anexo" v-model="showModalAnexo" centered hide-footer>
    <div>
      <div class="card-body">
        <h4 class="card-title">Selecionar novo arquivo</h4>
        <DropZone @change="selectedFile" />
        <span class="file-info">Arquivo: {{ dropzoneFile.name }}</span>
        <div v-if="submittedAnexo && !dropzoneFile.name" >
          <span class="text-danger font-size-11">Favor selecionar o arquivo e tentar novamente.</span>
        </div>
      </div>

      <div class="card-body">
        <div class="row">
          <div class="col-md-12">
            <label for="descranexo">Descrição</label>
            <div class="position-relative">
              <input
                  id="descranexo"
                  type="text"
                  v-model="descranexo"
                  class="form-control"
                  placeholder="Descrição do anexo"
                  :class="{'is-invalid': submittedAnexo && !descranexo}"/>
              <div v-if="submittedAnexo && !descranexo" class="invalid-feedback">
                <span>Campo descrição obrigatório, favor preencher.</span>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalAnexo = false">
          <i class="bx bx-block font-size-16 align-middle me-2"></i>
          Cancelar
        </b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="confAnexo">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </div>
  </b-modal>

</template>


<style scoped>
.full-height-wrapper {
  height: 100vh;
  overflow: hidden;
}

.full-height-card {
  height: 100%;
  margin-bottom: 0;
  border-radius: 0;
}

.full-height-body {
  height: 100%;
  overflow: hidden;
}


.btn-compact {
  background: none;
  border: 1px solid #ddd;
  padding: 3px 6px;
  border-radius: 3px;
  font-size: 12px;
  min-width: 28px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-compact:hover {
  background-color: #f5f5f5;
}

.compact-input {
  font-size: 12px;
  padding: 4px 6px;
  height: 32px;
  border-radius: 3px;
  border: 1px solid #ddd;
  width: 100%;
}

.compact-input:focus {
  border-color: #007bff;
  box-shadow: 0 0 0 1px rgba(0,123,255,.25);
  outline: none;
}

.compact-input.is-invalid {
  border-color: #dc3545;
}

.error-msg {
  font-size: 9px;
  color: #dc3545;
  margin-top: 2px;
}

.client-info {
  background: #f8f9fa;
  padding: 4px 6px;
  border-radius: 3px;
  margin-bottom: 6px;
  font-size: 10px;
}

.client-name {
  font-weight: 600;
  display: block;
  color: #333;
  line-height: 1.2;
}

.client-detail {
  color: #666;
  font-size: 9px;
}

.item-info {
  background: #e8f4f8;
  padding: 4px 6px;
  border-radius: 3px;
  margin-bottom: 8px;
  font-size: 10px;
}

.item-row {
  display: flex;
  justify-content: space-between;
  line-height: 1.3;
}

.item-label {
  font-weight: 600;
  color: #555;
}

.item-value {
  color: #333;
  font-weight: 500;
}

.nav-buttons {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 10px;
  background: #fff;
  display: flex;
  justify-content: space-between;
  border-top: 1px solid #ddd;
  z-index: 1000;
  gap: 6px;
}

.btn-nav {
  flex: 1;
  padding: 6px 4px;
  font-size: 10px;
  font-weight: 600;
  border-radius: 3px;
  border: 1px solid;
  background: white;
  height: 28px;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-back {
  border-color: #6c757d;
  color: #6c757d;
}

.btn-back:hover:not(:disabled) {
  background-color: #6c757d;
  color: white;
}

.btn-back:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn-next {
  border-color: #28a745;
  color: #28a745;
}

.btn-next:hover {
  background-color: #28a745;
  color: white;
}
</style>